import{a}from"./chunk-RAAYCPUM.js";function d(...e){return a(i,e)}function i(e,o){let t={};for(let[r,n]of Object.entries(e))o(n,r,e)&&(t[r]=n);return t}export{d as a};
